module.exports = __webpack_public_path__ + "img/qianlan.b684f9f8.png";